import { type CSSProperties, useMemo, useRef } from 'react'

import { Tooltip } from 'shared/ui/Tooltip'
import { cssColors } from 'shared/ui/utils/cssTokens'

import styles from './ProductTags.module.scss'

interface ProductTagsProps {
  name?: string
}

const ProductTags = ({ name }: ProductTagsProps) => {
  const ref = useRef<HTMLElement | null>(null)
  const colors = useMemo(() => {
    switch (name?.toLowerCase()) {
      case 'wyprzedaż':
        return {
          background: cssColors.brand.tertiaryLight,
          font: cssColors.brand.tertiary
        }
      case 'promocja':
        return {
          background: cssColors.brand.tertiary,
          font: cssColors.text.baseOnDark
        }
      case 'bestseller':
        return {
          background: cssColors.brand.quinary,
          font: cssColors.brand.primary
        }
      case 'megahit':
        return {
          background: cssColors.brand.secondary,
          font: cssColors.text.baseOnDark
        }
      case 'nowość':
      default:
        return {
          background: cssColors.brand.quaternary,
          font: cssColors.brand.primary
        }
    }
  }, [name])

  const isElipsed = useMemo(() => {
    if (ref?.current && ref?.current?.scrollWidth > ref?.current?.clientWidth) {
      return true
    }

    return false
  }, [ref?.current])

  const style = {
    '--promotion-tag-color': colors.font,
    '--promotion-tag-background': colors.background
  } as CSSProperties

  if (!name) return null

  if (isElipsed) {
    return (
      <Tooltip id={`promotion-tags-tooltip-${name}`} title={name}>
        <mark className={styles.root} style={style} ref={ref}>
          {name}
        </mark>
      </Tooltip>
    )
  }

  return (
    name && (
      <mark className={styles.root} style={style} ref={ref}>
        {name}
      </mark>
    )
  )
}

export default ProductTags
